import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiFormLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 500,
      color: '#939DB8',
      '&:not(.radio-label):not(.principal-amount):not(.MuiInputLabel-sizeSmall)': {
        top: '6px',
      },
      '&:not(.radio-label):not(.date-custom-label):not(.principal-amount):not(.custom-autocomplete-label)': {
        left: '4px !important',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
      '&.date-custom-label': {
        color: '#939DB8',
        position: 'absolute',
        top: '6px',
        left: '16px ',
        marginBottom: 0,
        fontSize: '12px',
        lineHeight: 1.5,
      },
      '&.radio-label': {
        color: '#071B3A',
        fontSize: '16px',
        lineHeight: '24px',
        '&.Mui-focused': {
          color: '#071B3A',
        },
        '&.Mui-error': {
          color: '#071B3A',
        },
      },
      '&.MuiInputLabel-shrink': {
        top: '3px !important',
        fontSize: '12px',
        lineHeight: 1.5,
        transform: 'translate(12px, 7px)',
        '&.MuiInputLabel-sizeSmall': {
          display: 'none',
        },
      },
      '&.Mui-error': {
        color: '#939DB8',
      },
      '&.Mui-error.MuiInputLabel-shrink': {
        color: '#939DB8',
      },
      '&.Mui-focused': {
        color: '#939DB8',
      },
      '&.Mui-disabled': {
        color: '#939DB8',
      },
    }),
  },
};
